import {
  createAsyncThunk,
  createSlice
} from "@reduxjs/toolkit";

import UserService from "../../services/user.service";

export const getUsers = createAsyncThunk(
  "user/getUsers",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getUser(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

/* APPROVE USER */

export const approveUser = createAsyncThunk(
  "user/approveUser",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.approveUser(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const getTeam = createAsyncThunk(
  "user/getTeam",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getTeam(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const getWallet = createAsyncThunk(
  "user/getWallet",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getWallet(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const getuserWallet = createAsyncThunk(
  "user/getuserWallet",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getuserWallet(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const getBankDetails = createAsyncThunk(
  "user/getBankDetails",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getBankDetails(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);



export const getWithdrawalRequests = createAsyncThunk(
  "user/getWithdrawalRequests",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getWithdrawalRequests(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const getBankAccount = createAsyncThunk(
  "user/getBankAccount",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.getBankAccount(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const approveBankAccount = createAsyncThunk(
  "user/approveBankAccount",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.approveBankAccount(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const approveWithdrawal = createAsyncThunk(
  "user/approveWithdrawal",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.approveWithdrawal(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const rejectWithdrawal = createAsyncThunk(
  "user/rejectWithdrawal",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.rejectWithdrawal(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const addBankDetails = createAsyncThunk(
  "user/addBankDetails",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.addBankDetails(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);

export const requestWithdrawal = createAsyncThunk(
  "user/requestWithdrawal",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.requestWithdrawal(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const editBankDetails = createAsyncThunk(
  "user/editBankDetails",
  async (item, thunkApi) => {

    try {

      const response =
        await UserService.editBankDetails(item);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


export const deleteBankDetails = createAsyncThunk(
  "user/deleteBankDetails",
  async (id, thunkApi) => {

    try {

      const response =
        await UserService.deleteBankDetails(id);

      return response.data;

    } catch (error) {

      return thunkApi.rejectWithValue(
        error.response?.data?.message ||
        error.message
      );
    }
  }
);


/* INITIAL STATE */

const initialState = {
  loading: false,
  error: "",

  users: [],
  pagination: null,

  selectedUser: null,

  team: [],
  wallet: null,
  walletTransactions: [],
  bankDetails: [],
  bankAccount: [],
  withdrawalRequests: [],
};
/* SLICE */

const userSlice = createSlice({

  name: "user",

  initialState,

  reducers: {},

  extraReducers: (builder) => {

    builder

      /* GET USERS */

      .addCase(getUsers.pending, (state) => {

        state.loading = true;

        state.error = "";

      })

      .addCase(getUsers.fulfilled, (state, action) => {

        state.loading = false;

        state.users =
          action.payload?.data || [];
        state.pagination = {
          page: action.payload?.page || 1,
          limit: action.payload?.limit || 10,
          totalCount:
            action.payload?.totalCount || 0,
          totalPages:
            action.payload?.totalPages || 1,
        };
      })

      .addCase(getUsers.rejected, (state, action) => {

        state.loading = false;

        state.error = action.payload;
      })

      /* GET TEAM */
      .addCase(getuserWallet.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(getuserWallet.fulfilled, (state, action) => {
        state.loading = false;

        state.wallet =
          action.payload?.walletSummary ||
          action.payload?.wallet ||
          null;

        state.walletTransactions =
          action.payload?.transactions ||
          action.payload?.data ||
          [];
      })

      .addCase(getuserWallet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTeam.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getTeam.fulfilled, (state, action) => {
        state.loading = false;
        state.team = action.payload;
      })

      .addCase(getTeam.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addBankDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(addBankDetails.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editBankDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(editBankDetails.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(editBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getWithdrawalRequests.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getWithdrawalRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.withdrawalRequests = action.payload?.data || [];
      })
      .addCase(getWithdrawalRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(requestWithdrawal.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(requestWithdrawal.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(requestWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(approveBankAccount.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(approveBankAccount.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(approveBankAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(approveWithdrawal.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(approveWithdrawal.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(approveWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(rejectWithdrawal.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(rejectWithdrawal.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(rejectWithdrawal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteBankDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(deleteBankDetails.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(deleteBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getBankDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getBankDetails.fulfilled, (state, action) => {
        state.loading = false;

        state.bankDetails =
          action.payload?.data || [];
      })

      .addCase(getBankDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getBankAccount.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getBankAccount.fulfilled, (state, action) => {
        state.loading = false;

        state.bankAccount =
          action.payload?.data || [];
      })

      .addCase(getBankAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      /* GET WALLET */

      .addCase(getWallet.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(getWallet.fulfilled, (state, action) => {
        state.loading = false;

        state.wallet =
          action.payload?.walletSummary ||
          action.payload?.wallet ||
          null;

        state.walletTransactions =
          action.payload?.transactions ||
          action.payload?.data ||
          [];
      })

      .addCase(getWallet.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* APPROVE USER */

      .addCase(approveUser.pending, (state) => {

        state.loading = true;

        state.error = "";
      })

      .addCase(approveUser.fulfilled, (state) => {

        state.loading = false;
      })

      .addCase(approveUser.rejected, (state, action) => {

        state.loading = false;

        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;